export class RequiredOrderIdError extends Error {
  constructor() {
    super('Required order id');
  }
}
